import { Flex, Loader } from '@mantine/core';

export const PageLoader = () => {
  return (
    <Flex direction="column" align="center" pt="xl">
      <Loader />
    </Flex>
  );
};
